// officialCareerStats.js
// Updated: March 9, 2026 — after Thailand GP Round 1
// Career stats include MotoGP class only (wins/poles/podiums/FL)
// World titles = combined across Moto3 + Moto2 + MotoGP

export const OFFICIAL_CAREER_STATS = {
  'Marc Márquez': {
    careerStats: { wins: 65, poles: 74, podiums: 126, fastest_laps: 64, races_completed: 210 },
    worldTitles: 9, // 125cc(1) + Moto2(1) + MotoGP(7)
  },
  'Marc Marquez': {
    careerStats: { wins: 65, poles: 74, podiums: 126, fastest_laps: 64, races_completed: 210 },
    worldTitles: 9,
  },
  'Francesco Bagnaia': {
    careerStats: { wins: 31, poles: 31, podiums: 78, fastest_laps: 25, races_completed: 135 },
    worldTitles: 3, // Moto2(1) + MotoGP(2)
  },
  'Jorge Martín': {
    careerStats: { wins: 14, poles: 21, podiums: 47, fastest_laps: 14, races_completed: 101 },
    worldTitles: 2, // Moto3(1) + MotoGP(1)
  },
  'Jorge Martin': {
    careerStats: { wins: 14, poles: 21, podiums: 47, fastest_laps: 14, races_completed: 101 },
    worldTitles: 2,
  },
  'Marco Bezzecchi': {
    careerStats: { wins: 10, poles: 9, podiums: 31, fastest_laps: 8, races_completed: 91 },
    worldTitles: 0,
  },
  'Pedro Acosta': {
    careerStats: { wins: 0, poles: 1, podiums: 12, fastest_laps: 1, races_completed: 43 },
    worldTitles: 2, // Moto3(1) + Moto2(1)
  },
  'Fabio Quartararo': {
    careerStats: { wins: 10, poles: 18, podiums: 35, fastest_laps: 12, races_completed: 112 },
    worldTitles: 1, // MotoGP(1)
  },
  'Maverick Viñales': {
    careerStats: { wins: 14, poles: 21, podiums: 62, fastest_laps: 18, races_completed: 200 },
    worldTitles: 0,
  },
  'Maverick Vinales': {
    careerStats: { wins: 14, poles: 21, podiums: 62, fastest_laps: 18, races_completed: 200 },
    worldTitles: 0,
  },
  'Joan Mir': {
    careerStats: { wins: 3, poles: 2, podiums: 25, fastest_laps: 4, races_completed: 110 },
    worldTitles: 1, // MotoGP(1)
  },
  'Enea Bastianini': {
    careerStats: { wins: 7, poles: 4, podiums: 25, fastest_laps: 6, races_completed: 88 },
    worldTitles: 0,
  },
  'Brad Binder': {
    careerStats: { wins: 2, poles: 1, podiums: 20, fastest_laps: 5, races_completed: 111 },
    worldTitles: 1, // Moto3(1)
  },
  'Álex Rins': {
    careerStats: { wins: 6, poles: 6, podiums: 28, fastest_laps: 8, races_completed: 150 },
    worldTitles: 0,
  },
  'Alex Rins': {
    careerStats: { wins: 6, poles: 6, podiums: 28, fastest_laps: 8, races_completed: 150 },
    worldTitles: 0,
  },
  'Jack Miller': {
    careerStats: { wins: 7, poles: 4, podiums: 25, fastest_laps: 8, races_completed: 180 },
    worldTitles: 0,
  },
  'Álex Márquez': {
    careerStats: { wins: 4, poles: 5, podiums: 25, fastest_laps: 5, races_completed: 102 },
    worldTitles: 2, // Moto3(1) + Moto2(1)
  },
  'Alex Marquez': {
    careerStats: { wins: 4, poles: 5, podiums: 25, fastest_laps: 5, races_completed: 102 },
    worldTitles: 2,
  },
  'Fabio Di Giannantonio': {
    careerStats: { wins: 2, poles: 2, podiums: 8, fastest_laps: 2, races_completed: 75 },
    worldTitles: 0,
  },
  'Franco Morbidelli': {
    careerStats: { wins: 2, poles: 3, podiums: 15, fastest_laps: 5, races_completed: 130 },
    worldTitles: 1, // Moto2(1)
  },
  'Raúl Fernández': {
    careerStats: { wins: 1, poles: 2, podiums: 7, fastest_laps: 2, races_completed: 76 },
    worldTitles: 0,
  },
  'Raul Fernandez': {
    careerStats: { wins: 1, poles: 2, podiums: 7, fastest_laps: 2, races_completed: 76 },
    worldTitles: 0,
  },
  'Johann Zarco': {
    careerStats: { wins: 2, poles: 8, podiums: 15, fastest_laps: 8, races_completed: 170 },
    worldTitles: 2, // Moto2(2)
  },
  'Ai Ogura': {
    careerStats: { wins: 0, poles: 1, podiums: 3, fastest_laps: 1, races_completed: 23 },
    worldTitles: 0,
  },
  'Luca Marini': {
    careerStats: { wins: 0, poles: 0, podiums: 8, fastest_laps: 1, races_completed: 85 },
    worldTitles: 0,
  },
  'Toprak Razgatlıoğlu': {
    careerStats: { wins: 0, poles: 0, podiums: 0, fastest_laps: 0, races_completed: 1 },
    worldTitles: 0,
  },
  'Toprak Razgatlioglu': {
    careerStats: { wins: 0, poles: 0, podiums: 0, fastest_laps: 0, races_completed: 1 },
    worldTitles: 0,
  },
  'Michele Pirro': {
    careerStats: { wins: 0, poles: 1, podiums: 2, fastest_laps: 1, races_completed: 65 },
    worldTitles: 0,
  },
  'Diogo Moreira': {
    careerStats: { wins: 0, poles: 0, podiums: 0, fastest_laps: 0, races_completed: 1 },
    worldTitles: 0,
  },
  'Fermín Aldeguer': {
    careerStats: { wins: 0, poles: 0, podiums: 0, fastest_laps: 0, races_completed: 22 },
    worldTitles: 1, // Moto2(1)
  },
  'Fermin Aldeguer': {
    careerStats: { wins: 0, poles: 0, podiums: 0, fastest_laps: 0, races_completed: 22 },
    worldTitles: 1,
  },
};

export function fetchOfficialCareerStats(riderName) {
  if (!riderName) return null;
  // Try exact match first
  if (OFFICIAL_CAREER_STATS[riderName]) return OFFICIAL_CAREER_STATS[riderName];
  // Try case-insensitive partial match
  const lower = riderName.toLowerCase();
  const key = Object.keys(OFFICIAL_CAREER_STATS).find(k => k.toLowerCase() === lower);
  return key ? OFFICIAL_CAREER_STATS[key] : null;
}
